/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is higher PPI always better?`)
};

const es_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Un PPI más alto siempre es mejor?`)
};

const de_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ein höherer PPI-Wert immer besser?`)
};

const nl_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een hogere PPI altijd beter?`)
};

const fr_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un PPP plus élevé est-il toujours meilleur ?`)
};

const it_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un PPI più alto è sempre meglio?`)
};

const pt_br2_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um PPI maior é sempre melhor?`)
};

const pt_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um PPI mais alto é sempre melhor?`)
};

const ja_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPIは高ければ高いほど良いのですか?`)
};

const zh_ppi_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPI 是不是越高越好？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_faq_q4", locale)
	if (locale === "en") return en_ppi_faq_q4(inputs)
	if (locale === "es") return es_ppi_faq_q4(inputs)
	if (locale === "de") return de_ppi_faq_q4(inputs)
	if (locale === "nl") return nl_ppi_faq_q4(inputs)
	if (locale === "fr") return fr_ppi_faq_q4(inputs)
	if (locale === "it") return it_ppi_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_faq_q4(inputs)
	if (locale === "pt") return pt_ppi_faq_q4(inputs)
	if (locale === "ja") return ja_ppi_faq_q4(inputs)
	return zh_ppi_faq_q4(inputs)
};